import { render, staticRenderFns } from "./Sandpit.vue?vue&type=template&id=7bb707c6&scoped=true"
import script from "./Sandpit.vue?vue&type=script&lang=js"
export * from "./Sandpit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb707c6",
  null
  
)

export default component.exports